import React from 'react'
import MyClass from '../../modules/MyClass'

const MyClassPage = () => {
  return <MyClass />
}

export default MyClassPage
